import {Checkbox} from '@chakra-ui/react';
import { useSelector } from 'react-redux';

export default function ChakraCheckbox({children, ...props}) {
    const {darkMode} = useSelector(state => state.settings)
    return <Checkbox borderColor={darkMode ? 'white': 'gray.400'} {...props}>{children}</Checkbox>;
}
